import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Navbar from './components/Navbar'
import MobileHeader from './components/MobileHeader'
import MobileBottomNav from './components/MobileBottomNav'
import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Astrology from './pages/Astrology'
// import Wellness from './pages/Wellness'
import Profile from './pages/Profile'
// import VoiceAssistant from './pages/VoiceAssistant'
import Subscription from './pages/Subscription'
import RraasiCoins from './pages/RraasiCoins'
import UserJourneyDashboard from './components/UserJourneyDashboard'
import Matchmaking from './pages/Matchmaking'
import GroupCompatibility from './pages/GroupCompatibility'
import GroupCompatibilityChat from './pages/GroupCompatibilityChat'
import PersonalChat from './pages/PersonalChat'
import StandaloneLivePersonalChat from './pages/StandaloneLivePersonalChat'
import LivePersonalChat from './pages/LivePersonalChat'
import MatchmakingChat from './pages/MatchmakingChat'
import EnhancedChatDemo from './pages/EnhancedChatDemo'
import TestChat from './pages/TestChat'
import PWAInstallPrompt from './components/PWAInstallPrompt'
import Reports from './pages/Reports'
import Launching from './pages/Launching'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'

function AppContent() {
  const location = useLocation();
  const isLaunchingPage = location.pathname === '/';

  return (
    <div className="min-h-screen cosmic-bg">
      {!isLaunchingPage && (
        <>
          <Navbar />
          <MobileHeader />
        </>
      )}
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={`mobile-container mobile-content ${!isLaunchingPage ? 'pt-20 lg:pt-4' : ''}`}
      >
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Launching />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            
            {/* Protected Routes */}
            <Route path="/astrology" element={
              <ProtectedRoute>
                <Astrology />
              </ProtectedRoute>
            } />
            <Route path="/group-compatibility" element={
              <ProtectedRoute>
                <GroupCompatibility />
              </ProtectedRoute>
            } />
            <Route path="/group-compatibility-chat" element={
              <ProtectedRoute>
                <GroupCompatibilityChat />
              </ProtectedRoute>
            } />
            <Route path="/personal-chat" element={
              <ProtectedRoute>
                <PersonalChat />
              </ProtectedRoute>
            } />
            <Route path="/live-personal-chat" element={
              <ProtectedRoute>
                <LivePersonalChat />
              </ProtectedRoute>
            } />
            <Route path="/matchmaking-chat" element={
              <ProtectedRoute>
                <MatchmakingChat />
              </ProtectedRoute>
            } />
            {/* <Route path="/wellness" element={<Wellness />} /> */}
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            {/* <Route path="/voice-assistant" element={<VoiceAssistant />} /> */}
            <Route path="/subscription" element={
              <ProtectedRoute>
                <Subscription />
              </ProtectedRoute>
            } />
            <Route path="/rraasi-coins" element={
              <ProtectedRoute>
                <RraasiCoins />
              </ProtectedRoute>
            } />
            <Route path="/user-journey" element={
              <ProtectedRoute>
                <UserJourneyDashboard />
              </ProtectedRoute>
            } />
            <Route path="/matchmaking" element={
              <ProtectedRoute>
                <Matchmaking />
              </ProtectedRoute>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/enhanced-chat" element={
              <ProtectedRoute>
                <EnhancedChatDemo />
              </ProtectedRoute>
            } />
            <Route path="/test-chat" element={
              <ProtectedRoute>
                <TestChat />
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            } />
          </Routes>
        </motion.main>
        
        {/* PWA Install Prompt */}
        <PWAInstallPrompt />
        
        {/* Mobile Bottom Navigation */}
        {!isLaunchingPage && <MobileBottomNav />}
      </div>
  );
}

function App() {
  // Test if React is working
  React.useEffect(() => {
    console.log('App component mounted')
  }, [])

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App 